import React from 'react';

export const SkipLink: React.FC<{ targetId?: string }> = ({ targetId = 'main-content' }) => {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-100 px-3 py-2 rounded-md bg-primary text-primary-foreground shadow"
    >
      Pular para o conteúdo
    </a>
  );
};


